import request from './request.js';

const api = {
	/**
	 * 获取省
	 */
	getProvint() {
		return request.get('/api/City/GetProvint')
	},
	/**
	 * 获取有人员的省份
	 */
	getProvintByTypes(types) {
		return request.get('/api/Hospital/GetProvint',{
			types:types ,
		})
	},
	/**
	 * 获取省级下的医院
	 * @param areaId 省份ID
	 */
	getHospital(areaId, types) {
		return request.get('/api/Hospital/GetHospital', {
			areaId: areaId, types: types
		})
	},
	/**
	 * 获取医院里的医生
	 * @param hospitalId 医院ID
	 */
	getDoctor(hospitalId, types) {
		return request.get('/api/User/GetList', {
			areaId: hospitalId,
			types: types,
			isPage: false,
			PageIndex: 0,
			PageSize: 10
		})
	},
	/**
	 * 在线
	 */
	onLine() {
		return request.post('/api/Hospital/OnLine')
	},
	/**
	 * 获取医生是否在线
	 */
	getDocOnLineStatus() {
		return request.get('/api/Hospital/GetDocOnLineStatus')
	},
	/**
	 * 离线
	 */
	offLine() {
		return request.post('/api/Hospital/OffLine')
	},
	/**
	 * 发启视频
	 * @param hospitId 医院ID
	 */
	call(hospitId) {
		return request.post('/api/Hospital/Call', null, {
			hospitId: hospitId
		})
	},
	/**
	 * 获取急救常识List
	 */
	getEmArticel(param) {
		return request.get('/api/Hospital/GetEmArticel', param)
	},
	/**
	 * 获取急救常识详细
	 */
	GetEmArticle(id) {
		return request.get('/api/Hospital/GetEmArticle', {
			id: id
		})
	},

	/**
	 * 获取医生简介列表
	 */
	getDoctors(param) {
		return request.get('/api/Hospital/GetDoctors', param)
	},
	/**
	 * 获取医生简介详细
	 */
	getTeacher(id) {
		return request.get('/api/Hospital/GetTeacher', {
			id: id
		})
	},
	/**
	 * 检查是否被邀请视频会议
	 */
	checkMeeting() {
		return request.get('/api/Hospital/checkMeeting')
	},
	/**
	 * 进入房间
	 */
	joinRoom(param) {
		return request.post('/api/Hospital/JoinRoom', null, param)
	},
	/**
	 * 加入房间
	 */
	requestJoinRoom(param) {
		return request.post('/api/Hospital/RequestJoinRoom', null, param)
	},
	/**
	 * 退出房间
	 */
	leaveRoom(param) {
		return request.post('/api/Hospital/LeaveRoom', null, param)
	},
	/**
	 * 结束救助电话会议
	 */
	endRoom(param) {
		return request.post('/api/Hospital/EndRoom', null, param)
	},
	/**
	 * 获取还没有结束的会议
	 */
	getUnEndRoom() {
		return request.get('/api/Hospital/GetUnEndRoom')
	},
	/**
	 * 检查房间状态
	 */
	checkRoomOpen(roomId) {
		return request.get('/api/Hospital/checkRoomOpen', {
			roomId: roomId
		})
	},
	getToken(roomId, userId){
		return request.get('/zego/getToken?room_id='+roomId+'&userId='+userId)
  
	},
	/**
	 * 获取视频记录
	 */
	getRecords(data) {
		return request.get('/api/Hospital/GetRecords', data)
	},
	/**
	 * 申请出警
	 */
	do1(param) {
		return request.post('/api/Hospital/do1', null, param)
	},
	/**
	 * 是否出警:1出警，2不用出警
	 */
	do2(param) {
		return request.post('/api/Hospital/do2', null, param)
	},
	/**
	 * 聊天记录 发送
	 */
	send(param) {
		return request.post('/api/MsgRecord/Send', null, param)
	},
	/**
	 * 聊天记录 列表
	 */
	getListMsg(param) {
		return request.get('/api/MsgRecord/GetList', param)
	},
	/**
	 * 文件上传
	 * @param {Object} base64
	 */
	uploadBase64(base64) {
		return request.post('/api/Upload/UploadBase64', {
			img: base64
		})
	},
}

export default api
